import { Outlet } from "react-router-dom";

export default function LoginLayout() {

  return (
    <div className=" sm:flex sm:flex-col lg:grid lg:grid-cols-7 h-screen">
      <div
        className="col-span-3 lg:h-full sm:h-1/6 flex flex-col justify-between w-full bg-primaryVar lg:relative"
        dir="rtl"
      >
        <div className=" md:hidden sm:hidden lg:flex lg:flex-col gap-5 text-white text-center p-20 z-50">
          <h2 className=" font-bold text-lg">به پنل مدیریت سپهرجو خوش آمدی</h2>
          <span className=" text-justify ">
            سپهرجو پلتفرم پرسش و پاسخ و مدیریت محتوای آموزشی است. از این پنل
            می‌توانید کاربران، سؤالات، پاسخ‌ها و بخش‌های مختلف سپهرجو را مدیریت
            کنید.
          </span>

        </div>
      </div>
      <div className="col-span-4 bg-backgroundPrimary">
        <Outlet />
      </div>
    </div>
  );
};